module.exports = __webpack_public_path__ + "img/CLIK_PROF_LOGO_SIN_FONDO.7d8f5b9b.png";